import React from "react";
import {
  TrainingCenterBundleCourse as ITrainingCenterBundleCourse,
  TrainingCenterBundleItem,
  TrainingCenterCaregiverBundle,
} from "../../../system/AppState/AppStateTrainingCenter";
import { TrainingCenterLanguagePreference } from "../../TrainingCenter/TrainingCenterLanguageLookup";
import { getCourseDescription, getCourseName } from "../../TrainingCenter/TrainingCenterUtils";
import TrainingCenterBundleItemCard from "./TrainingCenterBundleItemCard";

interface Props {
  bundle: TrainingCenterCaregiverBundle;
  course: ITrainingCenterBundleCourse;
  languagePreference: TrainingCenterLanguagePreference;
  onClickBundleItem: (bundleItem: TrainingCenterBundleItem) => void;
}

const TrainingCenterBundleCourse = (props: Props) => {
  const courseName = getCourseName(props.course, props.languagePreference);
  const courseDescription = getCourseDescription(props.course, props.languagePreference);

  return (
    <div className="TrainingCenterBundleCourse">
      <div className="title">{courseName}</div>
      <div className="description">{courseDescription}</div>
      <div className="lessons">
        {props.course.bundleItems.map((bundleItem) => (
          <TrainingCenterBundleItemCard
            key={`bundle-item-${bundleItem.bundleItemId}`}
            bundle={props.bundle}
            bundleItem={bundleItem}
            languagePreference={props.languagePreference}
            onClick={props.onClickBundleItem}
          />
        ))}
      </div>
    </div>
  );
};

export default TrainingCenterBundleCourse;
